import React, { useCallback, useEffect, useState } from 'react';
import { Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';

import { useCreateLessonMutation } from '@classCreation/services/lessonService';
import FieldErrors from 'components/FieldErrors';
import Form from 'components/Form';
import LessonInput from '../LessonInput';

export default function CreateLessonForm({
  academyTopicId,
  lessonType,
  onSuccess,
  label,
}) {
  const [lesson, setLesson] = useState();
  const [createLesson, { isSuccess, error, isLoading: isCreating }] =
    useCreateLessonMutation(academyTopicId);

  const handleOnChange = useCallback((newLesson) => {
    setLesson(newLesson);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Lesson is successfully created!');
      onSuccess();
    }
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in creating the lesson. Please try again later!'
      );
    }
  }, [error, isSuccess, onSuccess]);

  const handleCreateLesson = useCallback(
    (event) => {
      event.preventDefault();
      createLesson({
        academyTopicId,
        lesson,
      });
    },
    [academyTopicId, createLesson, lesson]
  );

  return (
    <Form
      onSubmit={handleCreateLesson}
      className="p-b-xl"
    >
      <LessonInput
        lessonType={lessonType}
        value={lesson}
        onChange={handleOnChange}
        placeholder={`Enter ${label}`}
      />
      <div className="h6 disabled m-t-xxs">
        If no slug id is added, then a blank test will be created for you, to
        which you can add problems later.
      </div>
      <FieldErrors
        name="duration"
        errors={error?.data?.errors}
      />
      <FieldErrors
        name="test_id"
        errors={error?.data?.errors}
      />
      <Tappable
        className="btn btn-primary m-v-xxs"
        disabled={isCreating}
        component="button"
        type="submit"
      >
        Create {label}
      </Tappable>
    </Form>
  );
}
